(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('.Product .js-product-smp-container').forEach(container => {
      if (container.dataset.treviSelectionLabels) return;
      container.dataset.treviSelectionLabels = 'true';
      const sync = () => {
        [['.ProductForm-itemSizes', 'Choose your count'], ['.ProductForm-itemFlavors', 'Choose your flavor']].forEach(([selector, text]) => {
          const group = container.querySelector(selector);
          if (!group || group.previousElementSibling?.classList.contains('trevi-pdp-selection-label')) return;
          const label = document.createElement('p');
          label.className = 'trevi-pdp-selection-label';
          label.textContent = text;
          group.before(label);
          group.setAttribute('role', 'group');
          group.setAttribute('aria-label', text);
        });
      };
      // The existing swatch script inserts these groups after its product request.
      new MutationObserver(sync).observe(container.querySelector('#js-product-smp') || container, {childList:true});
      sync();
    });
  };
  const imageBadge = () => {
    if (!/\/products\/[^/?]*variety-pack-favorites(?:[/?]|$)/i.test(location.pathname)) return;
    document.querySelectorAll('.Product .ProductGallery').forEach(gallery => {
      const slide = gallery.querySelector('.ProductGallery-mainSlide:not(.ProductGallery-video)');
      if (!slide || slide.querySelector('.trevi-pdp-best-seller-drop')) return;
      slide.classList.add('trevi-pdp-best-seller-image');
      const badge = document.createElement('div');
      badge.className = 'trevi-pdp-best-seller-drop';
      badge.innerHTML = '<svg viewBox="0 0 100 120" aria-hidden="true"><path d="M50 2C42 22 7 53 7 77a43 43 0 0 0 86 0C93 53 58 22 50 2Z" fill="#78cfe5"/></svg><span>Best<br>Seller</span>';
      slide.append(badge);
    });
  };
  initialize();
  imageBadge();
  document.addEventListener('shopify:section:load', imageBadge);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
